import { Navigate, useRoutes } from 'react-router-dom';
//General
import DashboardLayout from 'sections/layout';
import PageNotFound from 'pages/404App';
//Dashboard
import DashboardApp from 'pages/DashboardApp';
//Balance
import BalanceApp from 'pages/BalanceApp';
//Beneficiary
import BeneficiaryApp from 'pages/BeneficiaryApp';
import BeneficiarySteps from 'sections/beneficiary/upsert';
import BeneficiaryDetails from 'sections/beneficiary/details';
//convert
import ConvertApp from 'pages/ConvertApp';
import ConvertSteps from 'sections/convert/upsert';
//Contact support
import ContactSupport from 'sections/contact/ContactSupport';
//pay
import PayApp from 'pages/PayApp';
import PaySteps from 'sections/pay/upsert';
import PayProfile from 'sections/pay/profile';
//refund
import RefundProfile from 'sections/refund/profile';
//constants
import { pagesEnum } from 'constants/ui.constants';
import { UserPermission } from 'constants/user.constants';
import RequestApp from 'pages/RequestApp';
import SettingsApp from 'pages/SettingsApp';
import ActivityApp from 'pages/ActivityApp';
import BeneficiariesRequestDetails from 'sections/beneficiary/requestDetails';
import PayRequestDetails from 'sections/pay/requestDetails';
import ReportsApp from 'pages/ReportsApp';
import WelcomeApp from 'pages/WelcomeApp';
import PlansApp from 'pages/PlansApp';
import PlanPaymentApp from 'pages/PlanPaymentApp';
import { useAppSelector } from 'hooks/redux.hooks';
import { getMobile } from 'state/reducers/ui.reducers';
import MobileLayout from 'sections/layout/MobileLayout';
import AddBankAccount from 'sections/settings/bankAccounts/AddBankAccount';
import ProfileEdit from 'sections/settings/ProfileSettings/ProfileEdit';
import ReviewChange from 'sections/plans/ReviewChange';
import TermsApp from 'pages/TermsApp';
import PrivacyApp from 'pages/PrivacyApp';
import ProtectedRoute from 'components/ProtectedRoute';
import { getTerms } from 'state/reducers/user.reducers';
import ConvertProfile from 'sections/convert/profile';
import WithdrawalProfile from 'sections/balance/profile/withdrawal';
import ToppingProfile from 'sections/balance/profile/topping';

export default function Router(params: { permission: UserPermission }) {
	const isMobile = useAppSelector(getMobile);
	const isAllowed = useAppSelector(getTerms);

	return useRoutes([
		{
			path: '/' + pagesEnum.DASHBOARD,
			element: <DashboardLayout noCurrency={isMobile ? undefined : true} />,
			children: [{ path: '', element: <ProtectedRoute component={<DashboardApp />} /> }],
		},
		{
			path: '/' + pagesEnum.REPORT,
			element: <DashboardLayout />,
			children: [{ path: '', element: <ProtectedRoute component={<ReportsApp />} /> }],
		},
		{
			path: '/' + pagesEnum.SWIFT_TRACKING,
			element: <DashboardLayout />,
			children: [{ path: '', element: <ProtectedRoute component={<DashboardApp />} /> }],
		},
		{
			path: '/' + pagesEnum.BENEFICIARY,
			element: <DashboardLayout />,
			children: [{ path: '', element: <ProtectedRoute component={<BeneficiaryApp />} /> }],
		},
		{
			path: '/' + pagesEnum.BENEFICIARY,
			element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			children: [
				{ path: `edit/*`, element: <ProtectedRoute component={<BeneficiarySteps />} /> },
				{ path: `details/*`, element: <ProtectedRoute component={<BeneficiaryDetails />} /> },
				{ path: `pendingDetails/*`, element: <ProtectedRoute component={<BeneficiariesRequestDetails />} /> },
				{ path: `new`, element: <ProtectedRoute component={<BeneficiarySteps />} /> },
				{ path: pagesEnum.BALANCE, element: <ProtectedRoute component={<BalanceApp />} /> },
			],
		},
		{
			path: '/' + pagesEnum.CONVERT,
			element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			children: [
				{ path: '', element: <ProtectedRoute component={<ConvertApp />} /> },
				{ path: `edit/*`, element: <ProtectedRoute component={<ConvertSteps />} /> },
				{ path: `details/*`, element: <ProtectedRoute component={<BeneficiaryDetails />} /> },
				{ path: `new`, element: <ProtectedRoute component={<ConvertSteps />} /> },
				{ path: `profile/:id`, element: <ProtectedRoute component={<ConvertProfile />} /> },
			],
		},
		{
			path: '/' + pagesEnum.PAY,
			element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			children: [
				{ path: '', element: <ProtectedRoute component={<PayApp />} /> },
				{ path: `:type`, element: <ProtectedRoute component={<PaySteps />} /> },
				{ path: `:type/:id`, element: <ProtectedRoute component={<PaySteps />} /> },
				//{ path: `new/:id`, element: <ProtectedRoute component={<PaySteps />} /> },
				//{ path: `edit/:id`, element: <ProtectedRoute component={<PaySteps />} /> },
				{ path: `profile/:id`, element: <ProtectedRoute component={<PayProfile />} /> },
			],
		},
		{
			path: '/' + pagesEnum.REFUND,
			element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			children: [{ path: `profile/:id`, element: <ProtectedRoute component={<RefundProfile />} /> }],
		},
		{
			path: '/' + pagesEnum.BALANCE,
			// element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			element: <DashboardLayout />,
			children: [{ path: '', element: <ProtectedRoute component={<BalanceApp />} /> }],
		},
		{
			path: '/' + pagesEnum.REQUEST,
			element: <DashboardLayout />,
			children: [{ path: '', element: <ProtectedRoute component={<RequestApp />} /> }],
		},
		{
			path: '/' + pagesEnum.REQUEST,
			element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			children: [
				{ path: `requestDetailsBN/*`, element: <ProtectedRoute component={<BeneficiariesRequestDetails />} /> },
				{
					path: `requestDetailsPY/*`,
					element: <ProtectedRoute component={<PayRequestDetails allowActions={false} />} />,
				},
			],
		},
		// {
		//   path: '/' + pagesEnum.CONTACT,
		//   element: <ProtectedRoute component={<DashboardLayout />} />,
		//   children: [{ path: '', element: <ProtectedRoute component={<ContactSupport />} /> }],
		// },
		// {
		//   path: '/' + pagesEnum.CONTACT,
		//   element: <DashboardLayout />,
		//   children: [
		//     {
		//       path: '',
		//       element: <ProtectedRoute component={<ContactSupport />} />,
		//     },
		//   ],
		// },
		{
			path: '/' + pagesEnum.SETTINGS,
			element: <DashboardLayout />,
			children: [
				{ path: '', element: <ProtectedRoute component={<SettingsApp />} /> },
				{ path: ':type', element: <ProtectedRoute component={<SettingsApp />} /> },
			],
		},
		{
			path: '/' + pagesEnum.SETTINGS,
			element: isMobile ? <MobileLayout /> : <DashboardLayout />,
			children: [
				{ path: `addBankAccount`, element: <ProtectedRoute component={<AddBankAccount />} /> },
				{ path: `editProfile/:type`, element: <ProtectedRoute component={<ProfileEdit />} /> },
				// { path: `reviewPlanChange`, element: <ProtectedRoute component={<ReviewChange />} /> },
			],
		},
		{
			path: '/' + pagesEnum.ACTIVITY,
			element: <DashboardLayout />,
			children: [
				{ path: '', element: <ProtectedRoute component={<ActivityApp />} /> },
				{ path: ':reference', element: <ProtectedRoute component={<ActivityApp />} /> },
				{ path: 'profile/withdrawal/:id', element: <ProtectedRoute component={<WithdrawalProfile />} /> },
				{ path: 'profile/topping/:id', element: <ProtectedRoute component={<ToppingProfile />} /> },
			],
		},
		{
			path: '/' + pagesEnum.WELCOME,
			element: <DashboardLayout noCurrency nosidebar={true} />,
			children: [{ path: '', element: <WelcomeApp /> }],
		},
		// {
		//   path: '/' + pagesEnum.PLANS,
		//   element: <DashboardLayout noCurrency nosidebar={true} />,
		//   children: [{ path: '', element: <ProtectedRoute component={<PlansApp />} /> }],
		// },
		{
			path: '/' + pagesEnum.PAYMENT,
			element: <DashboardLayout noCurrency nosidebar />,
			children: [{ path: '', element: <ProtectedRoute component={<PlanPaymentApp />} /> }],
		},
		{
			path: '/' + pagesEnum.TERMS,
			element: <DashboardLayout noCurrency nosidebar={!isAllowed} />,
			children: [{ path: '', element: <TermsApp /> }],
		},
		{
			path: '/' + pagesEnum.PRIVACY,
			element: <DashboardLayout noCurrency nosidebar={!isAllowed} />,
			children: [{ path: '', element: <PrivacyApp /> }],
		},
		{
			path: '/',
			element: <Navigate to={`/${pagesEnum.DASHBOARD}`} replace />,
		},
		{
			path: '*',
			element: <Navigate to="/404" replace />,
		},
		{
			path: '/login',
			element: <>login</>,
		},
		{
			path: '/404',
			element: <PageNotFound />,
		},
	]);
}
